import angular from 'angular';
import '../../shared.module';
import template from './avatar.component.html';
import './avatar.component.scss';
import { initials } from '../../../core/helpers/string.helper';
import womanAvatarUrl from '../../../../public/avatar-mulher.png';
import firstManAvatarUrl from '../../../../public/avatar-homem-um.png';
import secondManAvatarUrl from '../../../../public/avatar-homem-dois.png';

export const DEFAULT_AVATARS = [womanAvatarUrl, firstManAvatarUrl, secondManAvatarUrl];

export function avatarIndexFor(key, count) {
  let hash = 0;
  for (let index = 0; index < key.length; index += 1) {
    hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
  }
  return hash % count;
}

export function defaultAvatarFor(key) {
  return key ? DEFAULT_AVATARS[avatarIndexFor(key, DEFAULT_AVATARS.length)] : null;
}

class AvatarController {
  constructor(UploadService) {
    this.UploadService = UploadService;
    this.fileImage = null;
    this.defaultImage = null;
    this.failedImages = new Set();
  }

  $onInit() {
    this.size = this.size || 36;
  }

  $onChanges(changes) {
    if (changes.name) {
      this.initials = initials(this.name);
    }
    if (changes.fallbackKey) this.defaultImage = defaultAvatarFor(this.fallbackKey);
    if (changes.fileId) this.loadFileImage();
  }

  get image() {
    const own = this.fileImage || this.src;
    if (own && !this.failedImages.has(own)) return own;
    if (this.defaultImage && !this.failedImages.has(this.defaultImage)) return this.defaultImage;
    return null;
  }

  imageFailed(url) {
    this.failedImages.add(url);
  }

  loadFileImage() {
    const fileId = this.fileId;
    this.fileImage = null;
    if (!fileId) return;
    this.UploadService.cachedFileUrl(fileId).then(
      (url) => {
        if (this.fileId === fileId) this.fileImage = url;
      },
      () => null
    );
  }
}

AvatarController.$inject = ['UploadService'];

angular.module('app.shared').component('cpAvatar', {
  bindings: {
    name: '@',
    src: '<',
    fileId: '@',
    fallbackKey: '@',
    size: '<',
    online: '<'
  },
  controller: AvatarController,
  controllerAs: 'vm',
  template
});
